import React from 'react';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

export interface PortfolioParagraphProps {
  strapi_component: string;
  id: string;
}

export const getComponentForDynamicPage = (
  item: PortfolioParagraphProps,
  components: Map<string, React.ComponentType<PortfolioParagraphContentProps>>,
) => {
  const Component = components.get(item.strapi_component);

  if (Component) {
    return <Component key={item.id} {...item} />;
  }

  return null;
};
